import { AsyncApiError } from 'Service/core/PoolTaskStatus'
import { notification } from 'antd'
import { ApiError } from 'Service/core/ApiError'
import { combineErrorMessages } from './helpers'

export const FailureHandler = (message: string, err: any, callback: Function = () => {}) => {
  console.info({ message, err, callback, type: typeof err })
  if (err instanceof ApiError || err instanceof AsyncApiError) {
    notification.error({
      message: message,
      description: combineErrorMessages(err.body),
      duration: 6,
    })
  }
  callback(err)
}

export type APIErrorResponseType = { message: string; service_code: number; service_name: string }

export function getNotificationContent(error: APIErrorResponseType) {
  return {
    message: `${error.service_name} ${error.service_code}`,
    description: error.message,
    duration: 6,
  }
}

export const ServiceFailureHandler = (error: APIErrorResponseType) => {
  notification.error(getNotificationContent(error))
}
